export const SummarySkeletonL: React.FC = () => {
  return (
    <>
      <div className={'pc'}>
        <div className="flex flex-wrap animate-pulse pc">
          {Array(4)
            .fill(0)
            .map((_, i) => (
              <div key={i} className="p-2 w-1/4 max-w-sm">
                <div className="flex-1 py-1 space-y-3">
                  <div className="h-20 sm:h-40 bg-gray-300 rounded"></div>
                  <div className="w-4/5 h-4 sm:h-6 bg-gray-300 rounded"></div>
                  <div className="w-1/3 h-3 sm:h-4 bg-gray-300 rounded"></div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className={'sp'}>
        <div className="flex flex-wrap animate-pulse">
          {Array(4)
            .fill(0)
            .map((_, i) => (
              <div key={i} className="p-2 w-1/2 max-w-sm">
                <div className="flex-1 py-1 space-y-2">
                  <div className="h-20 sm:h-40 bg-gray-300 rounded"></div>
                  <div className="w-4/5 h-4 sm:h-6 bg-gray-300 rounded"></div>
                  <div className="w-1/3 h-3 sm:h-4 bg-gray-300 rounded"></div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}
